exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".MixerInterface {\n  width: 95.83333%;\n  float: left;\n  margin-left: 2.08333%;\n  margin-right: 2.08333%; }\n  .MixerInterface-panels {\n    display: flex;\n    min-height: 435px;\n    padding-bottom: 40px; }\n  .MixerInterface-panel {\n    width: 50%; }\n    .MixerInterface-panel:first-child {\n      padding-right: 20px; }\n    .MixerInterface-panel:last-child {\n      padding-left: 20px; }\n  .MixerInterface .Mixer,\n  .MixerInterface .BinauralMixer {\n    margin-top: 24px; }\n", ""]);

// exports
